import type { AddFlagProps } from '@databases/flags/types';

import { messages } from './i18n';
import { MentionBuilder } from './mentionBuilder';
import { BuildProps, MentionBuilderCriteria } from './types';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers';

export class MentionFlagForMultipleUsers implements MentionBuilder {
  shouldShowFlag({ usersWithAccess }: MentionBuilderCriteria): boolean {
    return usersWithAccess.length > 2;
  }
  build({ formatMessage, usersWithAccess }: BuildProps): AddFlagProps {
    const { displayNamesCount, displayName, somebodyElse } = getDisplayNameForUsers({
      users: usersWithAccess,
    });

    return {
      title: formatMessage(
        messages[
          'mention-notification.flag-mention-notification-title-three-or-more-users'
        ],
        {
          displayName,
          somebodyElse,
          numOthers: (displayNamesCount - 2).toString(),
        }
      ),
      description: formatMessage(
        messages['mention-notification.flag-mention-notification-description']
      ),
    };
  }
}
